/**
 * Short description: click "Learn more" to show expanded copy (removes .hidden from .if-short-expanded_text).
 * Click again to hide. Expects [data-if-short-description] wrapper inside #MainProduct-*.
 *
 * Bootstrap (in section): window.shortDescriptionBootstrap.push('MainProduct-SECTION_ID');
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.shortDescriptionJsBound === 'true') return;
    root.dataset.shortDescriptionJsBound = 'true';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.if-short-description__toggle');
      if (!btn || !root.contains(btn)) return;

      var wrap = btn.closest('[data-if-short-description]');
      if (!wrap) return;

      var expandedEl = wrap.querySelector('.if-short-expanded_text');
      if (!expandedEl) return;

      var open = expandedEl.classList.contains('hidden') === false;
      if (open) {
        expandedEl.classList.add('hidden');
        wrap.classList.remove('if-short-description--expanded');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        expandedEl.classList.remove('hidden');
        wrap.classList.add('if-short-description--expanded');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function processBootstrapQueue() {
    var queue = window.shortDescriptionBootstrap;
    if (!queue || !queue.length) return;
    queue.forEach(function (elementId) {
      var el = document.getElementById(elementId);
      if (el) init(el);
    });
    window.shortDescriptionBootstrap = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processBootstrapQueue);
  } else {
    processBootstrapQueue();
  }
})();
